"use strict";
exports.__esModule = true;
exports.matchRequirements = exports.shouldShowResults = void 0;
var ui_common_1 = require("@codametrix/ui-common");
var ChargeSessionCodeProvenance = ui_common_1.commonEnums.ChargeSessionCodeProvenance;
var shouldShowResults = function (lookupState) {
    var active = lookupState.active, searching = lookupState.searching, codeQuery = lookupState.codeQuery;
    if (!active) {
        return false;
    }
    if (searching) {
        return true;
    }
    return matchRequirements(codeQuery);
};
exports.shouldShowResults = shouldShowResults;
var matchRequirements = function (codeQuery) {
    var _a = codeQuery.text, text = _a === void 0 ? '' : _a, _b = codeQuery.searchType, searchType = _b === void 0 ? '' : _b;
    return (text.length > 2 ||
        (text.length === 2 && searchType === ChargeSessionCodeProvenance.MODIFIER));
};
exports.matchRequirements = matchRequirements;
//# sourceMappingURL=show-results.js.map